export const LANGUAGES = {
    ARABIC: "ar",
    ENGLISH: "en",
};

export const ACTIVE_SYSTEM_LANGUAGES = [LANGUAGES.ENGLISH, LANGUAGES.ARABIC];
